import {Button, message, Modal, Popconfirm, Select, Spin, Tooltip} from 'antd'
import React from 'react'
import { CustomRow, CustomCol } from '../../components/Custom';
import DetailTitle from '../../components/DetailTitle';
import FileUpload_JR from '../../components/FileUpload_JR';
import { Row,Col,Form, Input } from "antd";


import {config, post, postFrom} from '../../axios';
import {
     API_CHECKLIST,
    API_device_findList, API_GETDEVICEPEPAIRREPORTBYID,
    API_salesroom_findList
} from '../../axios/config';
import Choose from "./Choose";
import AuthButton from "../../components/AuthButton/AuthButton";
const { TextArea } = Input;
class DeviceDetail extends React.Component{
  state = {
    id: null,
    visible: false,
    dataInfo: {},
      repairReportId: 0,
    salesroomList: [],
      deviceList:[],
    dataLoading: false,
    submitLoading: false,
    data: {
        houseLayout: []
    }
  }
  open(id = null) {
    if (id) {
      this.postHouseTypeGet(id)
    }
    this.postDeviceList();
    this.postSalesroomList()
    this.setState({ visible: true, id })
    return new Promise((resolve,reject) => {
      this.monitor = { resolve, reject }
    })
  }

  close() {
    this.setState({ visible: false ,data: {}})
    this.props.form.resetFields()
  }
  renderFooter() {
    return (
      <div className="app-modal-footer">
        <Button onClick={this.close.bind(this)}>取消</Button>
      </div>
    )
  }
  postSalesroomList() {
    post({ url: API_salesroom_findList }).then(res =>{
      this.setState({ salesroomList: res })
    })
  }
    postDeviceList() {
        post({ url: API_device_findList }).then(res =>{
            this.setState({ deviceList: res })
        })
    }
  postHouseTypeSubmit(data) {
    const url =  API_CHECKLIST+ '?houseId=' + this.state.id
    this.setState({ submitLoading: true })

    return post({ url, data }).then(res => {
       // this.setState({ submitLoading: false })
    }).finally(err => {
      this.setState({ submitLoading: false })
    })
  }
  postHouseTypeGet(id) {
    this.setState({ dataLoading: true,repairReportId: id })
    post({ url: API_GETDEVICEPEPAIRREPORTBYID + '?repairReportId=' + id  }).then(res => {
      const data = {
          buildingName: res.buildingName,
          merchantName: res.merchantName,
          ccbProjectName: res.ccbProjectName,
          floor: res.floor,
          projectName: res.projectName,
          categoryName:res.categoryName,
          deviceCategory:res.deviceCategory,
          deviceModel:res.deviceModel,
          houseName: res.houseName,
          createTime: res.createTime,
          roomTypeName: res.roomTypeName,
          userName:res.userName,
          repairStartDate:res.repairStartDate,
          repairEndDate:res.repairEndDate,
          phone:res.phone,
          notes:res.notes,
          radioValue: res.radioValue

      }
        if(res.fileUrls){
            this.fileUploadRef_Device.set(res.fileUrls.split('|'))
        }
        res.houseLayout = res.houseLayout.map((item, index) => { //添加一个key，以便增加一栏时数据不错乱
            item.key = index;
            item.f= item.notes;
            item.z =item.state==null ?"": item.state==1? '待处理': (item.state==2? '派单中': (item.state==3 ?'维修中' :'已完成')) ;
            item.t= item.merchantUserName;
            item.i= item.createTime;
            return item
        });

      this.props.form.setFieldsValue(data)
      this.setState({ data: res,dataLoading: false })
    }).catch(err => {
      this.setState({ dataLoading: false });
    })
  }
  handleSubmit() {
    this.props.form.validateFields((err, values) => {
      if (err) return
      values.id = this.state.id || undefined

      //根据房源Id提交核对清单


      this.postHouseTypeSubmit(values).then(() => {
        this.close()
        this.monitor.resolve()
        message.success('保存成功')
      }).catch((e) => {
        message.error(e.message)
      })
    })
  }
  render(){
    const modalConfig = {
      title: '报修详情',
      visible: this.state.visible,
      footer: this.renderFooter(),
      width: 1300,
      onCancel: () => this.close()
    }
  let {
      data,
  } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form
    const labelWidth = 70
    const labelValue = getFieldValue('label')
    return (
      <Modal {...modalConfig}>
        <Spin spinning={this.state.dataLoading}>
          <div className="custom" style={{padding: 20}}>
            <Form  labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
              <Row>
                <Col span={24}>
                  <DetailTitle title="基本信息" boxStyle={{ marginTop: '0' }} />
                  <CustomRow >
                    <CustomCol labelStyle={{ width: labelWidth }} label="项目名称">
                        {getFieldDecorator('projectName', {
                            rules: [{
                                required: true, message: '请选择所属门店',
                            }],
                        })(
                          <Input
                            placeholder={'请输入'}
                            autoComplete={'off'}
                            />
                        )}
                    </CustomCol>
                      <CustomCol labelStyle={{ width: labelWidth }} label="楼栋名称">
                          {getFieldDecorator('buildingName', {
                              rules: [{ required: true, message: '请输入户型名称', }],
                          })(
                              <Input
                                  placeholder={'请输入'}
                                  autoComplete={'off'}
                              />
                          )}
                      </CustomCol>
                      <CustomCol labelStyle={{ width: labelWidth }} label="门店名称">
                          {getFieldDecorator('ccbProjectName', {
                              rules: [{
                                  required: true, message: '请选择所属门店',
                              }],
                          })(
                              <Input
                                  placeholder={'请输入'}
                                  autoComplete={'off'}
                              />
                          )}
                      </CustomCol>

                  </CustomRow>
                    <CustomRow divider>

                        <CustomCol labelStyle={{ width: labelWidth }} label="楼层">
                            {getFieldDecorator('floor', {
                                rules: [{
                                    required: true, message: '请选择所属门店',
                                }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                        <CustomCol labelStyle={{ width: labelWidth }} label="房号">
                            {getFieldDecorator('houseName', {
                                rules: [{
                                    required: true, message: '请选择所属门店',
                                }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                        <CustomCol labelStyle={{ width: labelWidth }} label="户型品类">
                            {getFieldDecorator('categoryName', {
                                rules: [{ required: true, message: '请输入户型名称', }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol labelStyle={{ width: labelWidth }} label="设备品类">
                            {getFieldDecorator('deviceCategory', {
                                rules: [{
                                    required: true, message: '请选择所属门店',
                                }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                        <CustomCol labelStyle={{ width: labelWidth }} label="设备型号">
                            {getFieldDecorator('deviceModel', {
                                rules: [{
                                    required: true, message: '请选择所属门店',
                                }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                        <CustomCol labelStyle={{ width: labelWidth }} label="保修开始日期">
                            {getFieldDecorator('repairStartDate', {
                                rules: [{ required: true, message: '请输入户型名称', }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol labelStyle={{ width: labelWidth }} label="保修结束日期">
                            {getFieldDecorator('repairEndDate', {
                                rules: [{
                                    required: true, message: '请选择所属门店',
                                }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                        <CustomCol labelStyle={{ width: labelWidth }} label="报修日期">
                            {getFieldDecorator('createTime', {
                                rules: [{ required: true, message: '请输入户型名称', }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                        <CustomCol labelStyle={{ width: labelWidth }} label="服务类型">
                            {getFieldDecorator('radioValue', {
                                rules: [{ required: true, message: '服务类型', }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol labelStyle={{ width: labelWidth }} label="报修人姓名">
                            {getFieldDecorator('userName', {
                                rules: [{ required: true, message: '报修人姓名', }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                        <CustomCol labelStyle={{ width: labelWidth }} label="报修人手机">
                            {getFieldDecorator('phone', {
                                rules: [{
                                    required: true, message: '报修人手机',
                                }],
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="备注"  labelStyle={{ height: '100px' }} colStyle={{ width: '800px', height: '100px' }}>
                            {getFieldDecorator('notes', {
                            })(
                                <TextArea style={{ height: '100%', padding: '11px', lineHeight: '20px' }} />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <DetailTitle title="报修图片" />
                    <FileUpload_JR ref={(ref) => this.fileUploadRef_Device = ref}   />
                    <DetailTitle title="维修记录"  />
                    {
                        data.houseLayout instanceof Array
                            ? data.houseLayout.map((item, index) => {
                                return <CustomRow key={item.key}>
                                    <CustomCol labelStyle={{ width: '50px' }} label="处理状态">
                                        {getFieldDecorator(`z${item.key}`, {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: item.z
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol labelStyle={{ width: '270px' }} label="备注信息">
                                        {getFieldDecorator(`f${item.key}`, {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: item.f
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol labelStyle={{ width: labelWidth }} label="操作人">
                                        {getFieldDecorator(`t${item.key}`, {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: item.t
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol labelStyle={{ width: labelWidth }} label="操作时间">
                                        {getFieldDecorator(`i${item.key}`, {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: item.i
                                        })(
                                            <Input
                                                placeholder={'请输入'}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>
                            })
                            : null

                    }
                </Col>
              </Row>
            </Form>
          </div>
        </Spin>
          <div style={{position: "absolute", bottom: "16px", left: "16px"}}>
              <AuthButton authkey="z-3-4">
              <span className="showClickDetail" style={{textDecoration: "underline"}} onClick={this.handleChoose.bind()} >添加维修记录</span>
              </AuthButton>
          </div>
          <Choose
              onRef={ref => this.chooseRef = ref}
          />

      </Modal>
    )

  }
  handleMinus = (index) => { //房源户型减1
        let { data } = this.state;
        let item = data.houseLayout[index];
        if (item) {
            if (item.id) {
                this.setState({ loading: true });
                postFrom({ url: config.API_category_device_deleteDeviceLayout, data: { houseLayoutId: item.id } }).then(res => {
                    data.houseLayout.splice(index, 1);
                    this.setState({ data, loading: false });
                }).catch(err => {
                    message.error(err.message || '删除失败');
                    this.setState({ loading: false })
                });
            } else {
                data.houseLayout.splice(index, 1);
                this.setState({ data });
            }
        }
    }
    handleChoose = () => {
        if (this.chooseRef) {
            this.chooseRef.onShow(this.state.repairReportId).then(res => {
                console.log('222');
                this.postHouseTypeGet(this.state.id);
            }).catch(() => {})
        }
    }
    handlePlus = () => { //房源户型加1
        let { data } = this.state;
        if (data.houseLayout instanceof Array) {
            if (data.houseLayout.length) {
                data.houseLayout.push({ key: data.houseLayout[data.houseLayout.length - 1].key + 1, f: '', t: '', });
            } else {
                data.houseLayout.push({ key: 0, f: '', t: '' });
            }
        } else {
            data.houseLayout = [{ key: 0, f: '', t: '' }];
        }
        this.setState({ data });
    }

    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({ data: {}, loading: false, title: "新增小区/楼栋" });
    }
}



export default Form.create({ wrappedComponentRef: true })(DeviceDetail)


// WEBPACK FOOTER //
// ./src/page/DeviceRepairReport/deviceDetail.jsx